var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_1605_12455)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_1605_12455)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_1605_12455)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#5F6BE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_12455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 30.039C33.141 30.039 30 33.179 30 37.039C30 40.877 33.141 44 37 44C40.859 44 44 40.86 44 37C44 33.162 40.859 30.039 37 30.039ZM37 42C34.243 42 32 39.774 32 37.039C32 34.282 34.243 32.039 37 32.039C39.757 32.039 42 34.265 42 37C42 39.757 39.757 42 37 42ZM38.707 37.293C39.098 37.684 39.098 38.316 38.707 38.707C38.512 38.902 38.256 39 38 39C37.744 39 37.488 38.902 37.293 38.707L36.293 37.707C36.105 37.519 36 37.265 36 37V35C36 34.448 36.447 34 37 34C37.553 34 38 34.448 38 35V36.586L38.707 37.293ZM44 27V29C44 29.552 43.553 30 43 30C42.447 30 42 29.552 42 29V27C42 25.346 40.654 24 39 24H25C23.346 24 22 25.346 22 27V28H31C31.552 28 32 28.448 32 29C32 29.552 31.552 30 31 30H22V39C22 40.654 23.346 42 25 42H29C29.552 42 30 42.448 30 43C30 43.552 29.552 44 29 44H25C22.243 44 20 41.757 20 39V27C20 24.243 22.243 22 25 22H26V21C26 20.448 26.448 20 27 20C27.552 20 28 20.448 28 21V22H36V21C36 20.448 36.447 20 37 20C37.553 20 38 20.448 38 21V22H39C41.757 22 44 24.243 44 27Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_12455",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_12455",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1605_12455",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_12455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.be7f86ee1adafd8067448ad71872747d.svg";
export { ForwardRef as ReactComponent };